import { useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { FaShoppingCart, FaHeart, FaRegHeart, FaMinus, FaPlus } from "react-icons/fa";
import PageHeader from "../../components/layout/PageHeader";
import StarRating from "../../components/common/StarRating";
import { ProductCard } from "../../components/common/Cards";
import { useShop } from "../../context/ShopContext";
import { products } from "../../data/products";

export default function ProductSingle() {
  const { id } = useParams();
  const product = products.find((p) => p.id === id);
  const { addToCart, toggleWishlist, inWishlist } = useShop();
  const [qty, setQty] = useState(1);

  if (!product) return <Navigate to="/shop-grid" replace />;
  const related = products.filter((p) => p.category === product.category && p.id !== id).slice(0, 4);

  return (
    <>
      <PageHeader
        title={product.name}
        crumbs={[{ label: "Shop", to: "/shop-grid" }, { label: product.name }]}
      />
      <section className="section">
        <div className="container two-col">
          <div style={{ background: "#fff", borderRadius: 16, overflow: "hidden" }}>
            <img src={product.image} alt={product.name} style={{ width: "100%", height: 460, objectFit: "cover" }} />
          </div>
          <div>
            <span className="product-cat">{product.category}</span>
            <h2 style={{ fontSize: 32, margin: "8px 0 12px" }}>{product.name}</h2>
            <StarRating rating={product.rating} />
            <div className="product-price" style={{ justifyContent: "flex-start", margin: "16px 0" }}>
              <span className="now" style={{ fontSize: 28 }}>${product.price.toFixed(2)}</span>
              {product.oldPrice && <span className="old">${product.oldPrice.toFixed(2)}</span>}
            </div>
            <p className="sec-text" style={{ marginBottom: 24 }}>{product.desc}</p>

            <div className="flex gap-2 wrap" style={{ alignItems: "center", marginBottom: 24 }}>
              <div className="qty-box">
                <button onClick={() => setQty(Math.max(1, qty - 1))}><FaMinus /></button>
                <span>{qty}</span>
                <button onClick={() => setQty(qty + 1)}><FaPlus /></button>
              </div>
              <button className="btn btn-primary" onClick={() => addToCart(product, qty)}>
                <FaShoppingCart /> Add to Cart
              </button>
              <button className="btn btn-outline" onClick={() => toggleWishlist(product)}>
                {inWishlist(product.id) ? <FaHeart /> : <FaRegHeart />} Wishlist
              </button>
            </div>

            <table className="meta-table">
              <tbody>
                {product.specs.map((s, i) => (
                  <tr key={i}><td>{s[0]}</td><td>{s[1]}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="container" style={{ marginTop: 60 }}>
          <h2 style={{ fontSize: 26, marginBottom: 24 }}>Customer Reviews</h2>
          <div className="grid grid-2">
            {product.reviews.map((r, i) => (
              <div className="card" style={{ padding: 26 }} key={i}>
                <StarRating rating={5} />
                <p className="sec-text" style={{ margin: "12px 0" }}>"{r.text}"</p>
                <h4 className="text-yellow">{r.name}</h4>
              </div>
            ))}
          </div>
        </div>

        {related.length > 0 && (
          <div className="container" style={{ marginTop: 60 }}>
            <h2 style={{ fontSize: 26, marginBottom: 24 }}>Related Products</h2>
            <div className="grid grid-4">
              {related.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          </div>
        )}
      </section>
    </>
  );
}
